import { MessageSquare } from 'lucide-react';

interface MessageCounterProps {
  balance: number;
  mobile?: boolean;
}

export function MessageCounter({ balance, mobile = false }: MessageCounterProps) {
  if (mobile) {
    return (
      <div className="bg-[rgba(42,42,53,0.5)] border border-[rgba(255,255,255,0.08)] rounded-[10px] h-[44px] px-[16px] flex items-center gap-[12px] mt-[16px]">
        <MessageSquare className="w-[20px] h-[20px] text-white" />
        <span className="font-['Inter'] font-medium text-[16px] leading-[24px] text-white">{balance}</span>
        <span className="font-['Inter'] font-normal text-[14px] leading-[20px] text-[#9595a5]">Messages</span>
      </div>
    );
  }

  return (
    <div className="hidden md:flex bg-[rgba(42,42,53,0.5)] border border-[rgba(255,255,255,0.08)] rounded-[10px] h-[38px] px-[17px] py-px items-center gap-[8px]">
      <MessageSquare className="w-[16px] h-[16px] text-white" />
      <span className="font-['Inter'] font-medium text-[14px] leading-[20px] text-white">{balance}</span>
      <span className="font-['Inter'] font-normal text-[12px] leading-[16px] text-[#9595a5]">Messages</span>
    </div>
  );
}
